/**
 * A reusable component that displays a subheader for a card.
 *
 * @param {string} value - The text content of the subheader.
 * @param {boolean} [leftAlign=false] - Whether to align the subheader to the left.
 */
import { Typography } from "@mui/material";
import "./style.scss";
import PropTypes from 'prop-types'

const CardSubHeader = ( props ) =>
{
	const {
		value,
		leftAlign,
		customClass,
		id
		 } = props
	return (
		<>
			{value && (
				<Typography
					sx={{ mt: 1 }}
					id={`fxcm-card-subheader-${id ?? 1}`}
					align={leftAlign ? "left" : "center"}
					className={`subtext-cards ${customClass || ''}`}
				>
					{value}
				</Typography>
			)}
		</>
	);
};
CardSubHeader.propTypes = {
  value: PropTypes.string,
  leftAlign: PropTypes.string,
  customClass: PropTypes.string
}

export default CardSubHeader;
